import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout";
import { systemRoutes, flowRoutes } from "./system";
import { cusRoutes } from "./cusRoutes";

Vue.use(Router);

// 全局路由
export const allRoutes = [
  {
    path: "/login",
    meta: {
      title: "登陆",
    },
    component: () => import("@/login/index-local.vue"),
    // component: () => {
    //   if (process.env.NODE_ENV == "localtest") {
    //     return import("@/login/index-local.vue");
    //     // return import("@/login");
    //   } else {
    //     return import("@/login");
    //   }
    // },
  },
  {
    path: "*",
    component: Layout,
    redirect: "/welcome",
    children: [
      {
        path: "/welcome",
        meta: {
          title: "欢迎页面",
        },
        component: () => import("@/pages/welcome"),
      },
      {
        path: "/formList",
        meta: {
          title: "表单查看",
        },
        component: () => import("@/pages/formList"),
      },
      // 系统管理方面
      ...systemRoutes,

      // 流程相关
      ...flowRoutes,

      // 定制功能页面
      ...cusRoutes,
    ],
  },
];

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: allRoutes,
});
